









import {Component, Mixins} from 'vue-property-decorator';
import Control from './Control';

@Component({
    watch: {filledValue: 'updateValue'},
})
export default class TextControl extends Mixins<Control<string>>(Control) {
    protected filledValue: string = '';

    public created(): void {
        if (this.value === null) {
            return;
        }

        this.filledValue = this.value;
    }

    public input(event: any) {
        this.filledValue = event.target.value;
    }

    protected getValue(): string | null {
        return this.filledValue === '' ? null : this.filledValue;
    }
}
